export const iconUrls = [
    // dap 全局  2024.9.5
    '//at.alicdn.com/t/c/font_1508833_mh0b3jwnazb.js',
    // dap-ad 广告  2024.6.20
    '//at.alicdn.com/t/c/font_4351190_ox4abexrr8j.js',
    // dap-insight 工作表   2024.2.26
    '//at.alicdn.com/t/c/font_4292559_vw7bo6zc8y.js',
    // dap-creative 创意库  2024.2.26
    '//at.alicdn.com/t/c/font_3668254_mv6vxecrbjr.js',
    // dap-artascope 万花筒  2024.2.26
    '//at.alicdn.com/t/c/font_3598341_lt53yw2pa8.js',
    // dragonfly-web 蜻蜓建站   2024.2.26
    '//at.alicdn.com/t/c/font_4250733_ollzh52upig.js',
    // dap-aigc  aigc   2024.2.26
    '//at.alicdn.com/t/c/font_4290978_ymgqc57hilc.js',
    // dap-tools  tools   2024.6.4
    '//at.alicdn.com/t/c/font_4352379_57zby2p8y3j.js',
];

export const defaultDict = {
    // 广告通用字典
    'adDict.common': {
        // 投放类型
        deliveryType: [
            { name: '拉新', value: 1 },
            { name: '回流', value: 2 },
            { name: '混投', value: 3 },
        ],
        // 分包状态
        status: {
            subList: [
                { name: '分包未开始', value: '0' },
                { name: '分包中', value: '1' },
                { name: '分包完成', value: '2' },
                { name: '分包失败', value: '3' },
                { name: '分包排队中', value: '9' },
            ],
            // 推送状态
            syncList: [
                // { name: '推送中', value: '101' },
                { name: '待推送', value: '102' },
                { name: '推送数据一致', value: '103' },
                { name: '推送失败', value: '104' },
                { name: '待拉取', value: '201' },
                { name: '拉取中', value: '202' },
                { name: '拉取数据一致', value: '203' },
                { name: '推送中', value: '100' },
                { name: '推送成功，等待拉取', value: '105' },
            ],
        },
    },

    'adDict.trackLink': {
        mkt_goal: [
            { name: '应用推广', value: '1' },
            { name: '预约', value: 'reserve' },
        ],
        store_id: [
            { name: 'iOS', value: '1' },
            { name: 'Android', value: '2' },
            { name: 'PC', value: '3' },
        ],
        page_type: [
            { name: '落地页', value: '1' },
            { name: '接口', value: '2' },
            { name: '302', value: '3' },
            { name: '落地页且异步上报', value: '4' },
        ],
        jump_type: [
            { name: '直接跳转', value: '1' },
            { name: '点击跳转', value: '2' },
            { name: '停留3秒', value: '3' },
            { name: '停留5秒', value: '4' },
            { name: '停留10秒', value: '5' },
        ],
        status: [
            { name: '分包未开始', value: 0 },
            { name: '分包中', value: 1 },
            { name: '分包完成', value: 2 },
            { name: '分包失败', value: 3 },
            { name: '分包排队中', value: 9 },
        ],
        reserv_type: [
            { name: '直跳appstore', value: '1' },
            { name: '自建落地页表单', value: '2' },
            { name: '媒体落地页表单', value: '3' },
            { name: '媒体落地页按钮', value: '4' },
            { name: '双端自适应-1', value: '5' },
            { name: '小包预约', value: '6' },
            { name: '双端自适应-2', value: '7' },
            { name: '其它', value: '8' },
        ],
        mkt_type: [
            { value: '1', name: '应用推广' },
            { value: '2', name: '预约推广' },
        ],
    },
    'creativeDict.common': {
        recommend_type: [
            { value: '4', label: '高消高回', is_recommend: true },
            { value: '2', label: '低消高回', is_recommend: true },
            { value: '3', label: '高消低回', is_recommend: false },
            { value: '0', label: '未标记', is_recommend: false },
        ],
    },
    'tools.annotation': {
        commentTypeList: [
            {
                id: 1,
                name: '商品推荐',
                iconUrl: 'http://adpages.oss-cn-shanghai.aliyuncs.com/comment/comment-type-1.png',
            },
            {
                id: 2,
                name: '品牌活动',
                iconUrl: 'http://adpages.oss-cn-shanghai.aliyuncs.com/comment/comment-type-2.png',
            },
            {
                id: 3,
                name: '游戏版本更新',
                iconUrl: 'http://adpages.oss-cn-shanghai.aliyuncs.com/comment/comment-type-3.png',
            },
            {
                id: 4,
                name: '游戏运营活动',
                iconUrl: 'http://adpages.oss-cn-shanghai.aliyuncs.com/comment/comment-type-4.png',
            },
            {
                id: 5,
                name: '其他',
                iconUrl: 'http://adpages.oss-cn-shanghai.aliyuncs.com/comment/comment-type-5.png',
            },
            {
                id: 0,
                name: '',
                iconUrl: 'http://adpages.oss-cn-shanghai.aliyuncs.com/comment/comment-type-0.png',
            },
        ],
    },
    'tableDict.realtime': {
        targetList1: [
            {
                value: 'ins_num',
                name: '安装数',
            },
            {
                value: 'reserv_num',
                name: '预约数',
            },
            {
                value: 'reg',
                name: '激活数',
            },
            {
                value: 'cr',
                name: '创角数',
            },
        ],
        targetList2: [
            {
                value: 'newpay',
                name: '新充人数',
            },
            {
                value: 'newpay_amount',
                name: '新充流水',
            },
            {
                value: 'newpay_taxed_amount',
                name: '新充实收',
            },
            {
                value: 'allpay_amount',
                name: '总充流水',
            },
            {
                value: 'allpay_taxed_amount',
                name: '总充实收',
            },
        ],
        reservationTargetList1: [
            {
                value: 'click_num',
                name: '点击数',
            },
            {
                value: 'page_view',
                name: '落地页打开次数',
            },
            {
                value: 'page_view_count',
                name: '落地页打开人数(cookie跨天去重)',
            },
        ],
        reservationTargetList2: [
            {
                value: 'form_rez_num',
                name: '表单预约数',
            },
            {
                value: 'button_rez_num',
                name: '按钮预约数',
            },
            {
                value: 'button_click',
                name: '落地页按钮点击次数',
            },
            {
                value: 'button_click_count',
                name: '落地页按钮点击人数(cookie跨天去重)',
            },
        ],
        cloudTargetList1: [
            {
                value: 'ins_num',
                name: '微端安装数',
            },
            {
                value: 'reg',
                name: '微端激活数',
            },
            {
                value: 'cr',
                name: '微端创角数',
            },
            {
                value: 'clg_cvt',
                name: '整包转化数',
            },
            {
                value: 'clg_reg',
                name: '整包激活数',
            },
            {
                value: 'clg_cr',
                name: '整包创角数',
            },
        ],
        cloudTargetList2: [
            {
                value: 'newpay',
                name: '微端新充值人数'
            },
            {
                value: 'newpay_amount_rmb',
                name: '微端新充值流水'
            },
            {
                value: 'allpay',
                name: '微端总充值人数'
            },
            {
                value: 'allpay_amount_rmb',
                name: '微端总充值流水'
            },
            {
                value: 'clg_newpay',
                name: '整包新充值人数'
            },
            {
                value: 'clg_newpay_amount_rmb',
                name: '整包新充值流水'
            },
            {
                value: 'clg_allpay',
                name: '整包总充值人数'
            },
            {
                value: 'clg_allpay_amount_rmb',
                name: '整包总充值流水'
            },
        ],

        timeList: [
            {
                value: 'rt5',
                name: '按5分钟',
            },
            {
                value: 'rt60',
                name: '按小时',
            },
        ],
        timeTypeList: [
            {
                value: 'period',
                name: '分时',
            },
            {
                value: 'total',
                name: '累计',
            },
        ],
    },
    observatoryDict: {
        categoryList: [
            {
                value: 'no_group',
                name: '无',
            },
            {
                value: 'game',
                name: '游戏',
            },
            {
                value: 'appstore',
                name: '应用市场',
            },
            {
                value: 'region',
                name: '市场（地区）',
            },
            {
                value: 'top5_country',
                name: 'TOP5国家',
            },
            {
                value: 'top5_media_src',
                name: 'TOP5渠道',
            },
        ],
        timeTypeList: [
            {
                value: 'no_group',
                name: '无',
            },
            {
                value: 'day',
                name: '分日',
            },
            {
                value: 'week',
                name: '分周',
            },
            {
                value: 'month',
                name: '分月',
            },
            {
                value: 'quarter',
                name: '分季度',
            },
            {
                value: 'year',
                name: '分年',
            },
        ],
        financeList: [
            {
                value: 'no_group',
                name: '无',
            },
            {
                value: 'game',
                name: '游戏',
            },
            {
                value: 'ua_group',
                name: '区域',
            },
            {
                value: 'region',
                name: '市场',
            },
            {
                value: 'os',
                name: '操作系统',
            },
            {
                value: 'month',
                name: '分月',
            },
            {
                value: 'quarter',
                name: '分季度',
            },
            {
                value: 'year',
                name: '分年',
            },
            {
                value: 'dap_cost_amount',
                name: '总消耗数',
            },
            {
                value: 'dap_ua_cost',
                name: 'UA消耗数',
            },
            {
                value: 'dap_mkt_cost',
                name: '营销消耗数',
            },
            {
                value: 'dap_share',
                name: '分成款',
            },
            {
                value: 'dap_profit',
                name: '毛利润',
            },
            {
                value: 'dap_pay_amount',
                name: '总充值流水',
            },
            {
                value: 'dap_real_income',
                name: '总充值实收',
            },
            {
                value: 'ua',
                name: 'UA',
            },
            {
                value: 'mkt',
                name: '营销',
            },
            {
                value: 'fin_outcome',
                name: '总支出',
            },
            {
                value: 'fin_publish',
                name: '发行费用',
            },
            {
                value: 'fin_under_profit_cost',
                name: '毛利下支出',
            },
            {
                value: 'fin_share',
                name: 'CP分成款',
            },
            {
                value: 'fin_actual_outcome',
                name: '实际花费',
            },
            {
                value: 'fin_daily_outcome',
                name: '日常费用',
            },
            {
                value: 'fin_actual_income',
                name: '实收',
            },
            {
                value: 'fin_flow',
                name: '流水',
            },
            {
                value: 'fin_profit',
                name: '净利率',
                is_ratio: true,
            },
            {
                value: 'fin_gross_profit',
                name: '毛利率',
                is_ratio: true,
            },
            {
                value: 'fin_flow_refunded',
                name: '退款后账单流水',
            },
            {
                value: 'fin_profit_rate',
                name: '实际利润率',
                is_ratio: true,
            },
            {
                value: 'fin_gross_profit_rate',
                name: '实际毛利率',
                is_ratio: true,
            },
            {
                value: '实际花费',
                name: '实际花费',
            },
            {
                value: '日常费用',
                name: '日常费用',
            },
        ],
    },
    reAttributionArray: [
        { name: '永久归因', value: '0' },
        { name: '7天再归因', value: '7' },
        { name: '30天再归因', value: '30' },
    ],
};
